/**
 *
 * Polyfill for a future browser standard.
 *
 * requestIdleCallback will defer execution of a callback
 * until the browser has a spare cycle. This will help
 * mitigate and alleviate concerns regarding browsers
 * trying to multi-task too much at once.
 * 
 * @see https://developers.google.com/web/updates/2015/08/27/using-requestidlecallback
 * 
 * @param  {Function} callback
 */
module.exports = function requestIdleCallbackPolyfill(callback) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback);
  } else {
    callback();
  }
};
